import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import { useAuth } from "@/features/auth/AuthContext";
import { supabase } from "@/lib/supabase";
import type { ContentPiece } from "@/lib/database.types";

export function LibraryPage() {
  const { t } = useI18n();
  const { session } = useAuth();
  const [pieces, setPieces] = useState<ContentPiece[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("content_pieces")
      .select("*")
      .eq("user_id", session!.user.id)
      .eq("status", "done")
      .order("created_at", { ascending: false })
      .then(({ data }) => {
        setPieces(data ?? []);
        setLoading(false);
      });
  }, [session]);

  if (loading) return <p className="text-muted">{t("loading")}</p>;

  return (
    <div>
      <h1 className="mb-4 text-xl font-bold">{t("navLibrary")}</h1>
      {pieces.length === 0 ? (
        <p className="text-sm text-muted">—</p>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {pieces.map((p) => (
            <div key={p.id} className="card p-2">
              {p.image_url && (
                <img src={p.image_url} alt="" className="mb-2 w-full rounded-lg" />
              )}
              <p className="line-clamp-1 text-xs font-medium">{p.headline}</p>
              <p className="text-[10px] text-muted">{p.created_at.slice(0, 10)}</p>
              {p.image_url && (
                <a
                  className="mt-1 block text-center text-xs text-accent"
                  href={p.image_url}
                  download
                  target="_blank"
                  rel="noopener"
                >
                  {t("download")}
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
